var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 17,
    viewBox: "0 0 20 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.99902 16.293C1.44902 16.293 0.97819 16.0971 0.586523 15.7055C0.194857 15.3138 -0.000976562 14.843 -0.000976562 14.293V2.29297C-0.000976562 1.74297 0.194857 1.27214 0.586523 0.880469C0.97819 0.488802 1.44902 0.292969 1.99902 0.292969H17.999C18.549 0.292969 19.0199 0.488802 19.4115 0.880469C19.8032 1.27214 19.999 1.74297 19.999 2.29297V14.293C19.999 14.843 19.8032 15.3138 19.4115 15.7055C19.0199 16.0971 18.549 16.293 17.999 16.293H1.99902ZM9.99902 9.29297L1.99902 4.29297V14.293H17.999V4.29297L9.99902 9.29297ZM9.99902 7.29297L17.999 2.29297H1.99902L9.99902 7.29297ZM1.99902 4.29297V2.29297V14.293V4.29297Z",
    fill: "url(#paint0_linear_401_701)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_401_701",
    x1: -0.363844,
    y1: 8.62862,
    x2: 20.325,
    y2: 8.62862,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#895EF6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#F03063"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF7640"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/mail.850744ceeaa0b4c8f7164d555ce1fe1d.svg";
export { ForwardRef as ReactComponent };